module.exports = __webpack_public_path__ + "img/espagne.36938bbe.svg";